'use client';

import { __awaiter, __generator } from '../_virtual/_tslib.js';

var API_POST_TRACKING_EVENT = '/api-gateway/v1.0/candidate-report/popup-track-win-rate';
var API_GET_OPEN_STATUS = '/api-gateway/v1.0/candidate-report/popup-track-win-rate';
var apiTrackingEvent = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var baseUrl, accessToken, _a, langCode, postData, apiUrl, response, ex_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 3, , 4]);
                baseUrl = params.baseUrl, accessToken = params.accessToken, _a = params.langCode, langCode = _a === void 0 ? 'vi' : _a, postData = params.postData;
                apiUrl = "".concat(baseUrl).concat(API_POST_TRACKING_EVENT);
                return [4 /*yield*/, fetch(apiUrl, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: "Bearer ".concat(accessToken),
                            'Accept-Language': langCode
                        },
                        body: JSON.stringify(postData)
                    })];
            case 1:
                response = _b.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _b.sent()];
            case 3:
                ex_1 = _b.sent();
                console.error(ex_1);
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };
var apiGetOpenStatus = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var baseUrl, accessToken, _a, langCode, jobId, apiUrl, response, responseJson, ex_2;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 3, , 4]);
                baseUrl = params.baseUrl, accessToken = params.accessToken, _a = params.langCode, langCode = _a === void 0 ? 'vi' : _a, jobId = params.jobId;
                if (!jobId) {
                    return [2 /*return*/, false];
                }
                if (!accessToken) {
                    return [2 /*return*/, false];
                }
                apiUrl = "".concat(baseUrl).concat(API_GET_OPEN_STATUS, "?jobId=").concat(jobId);
                return [4 /*yield*/, fetch(apiUrl, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: "Bearer ".concat(accessToken),
                            'Accept-Language': langCode
                        }
                    })];
            case 1:
                response = _b.sent();
                return [4 /*yield*/, response.json()
                    // API return status true is close, false is open
                ];
            case 2:
                responseJson = _b.sent();
                // API return status true is close, false is open
                return [2 /*return*/, !responseJson.data.status];
            case 3:
                ex_2 = _b.sent();
                console.error(ex_2);
                return [2 /*return*/, false];
            case 4: return [2 /*return*/];
        }
    });
}); };

export { apiGetOpenStatus, apiTrackingEvent };
//# sourceMappingURL=services.js.map
